import React from 'react';

export default function Home(props) {

    const journalElements = props.journals.map((journal) => (
        <div className='md:w-72 w-full shadow-lg rounded-lg cursor-pointer border-2 border-transparent hover:border-sky-600 transition ease-in'
        key={journal.key}>
            <div className='bg-white dark:bg-[#101010] p-5 rounded-lg flex justify-between' onClick={() => {props.setCurrentJournalId(journal.id); props.toggle()}}>
                <div>
                    <span className="text-sky-600">Journal {journal.id}</span>
                    <h1 className='text-xl font-bold truncate dark:text-white'>{journal.title}</h1>
                </div>
                <div className='hover:text-red-700 dark:text-[#f4f4f4] transition ease-in'>
                    <svg onClick={(event) => props.deleteJournal(event, journal.id)} className='hover:text-red-700' viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
                </div>
            </div>
        </div>
    ))

    const dark = (
        <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path></svg>
    )

    const light = (
        <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line></svg>
    )

    return (
        <div>
            <div className='w-screen h-screen md:mb-5 mb-24'>
                <div className='dark:bg-[#101010] bg-white w-full md:h-[300px] h-[400px] flex justify-center'>
                    <div className='max-w-7xl w-full flex'>
                        <div className='my-auto p-10'>
                            <h1 className='text-sky-600 text-4xl font-bold'>HyperJournal</h1>
                            <p className='max-w-3xl mt-3 dark:text-white'>HyperJournal is a portfolio project made by Tanvir Bhachu. It's built uses React, the Mantine framework and Tailwind. The journals are saved in localStorage and everything is saved automatically in real-time.</p>
                            <div className='flex gap-5'>
                                <div onClick={props.newJournal} className='mt-4 rounded-lg px-5 py-2 bg-sky-600 w-fit text-white cursor-pointer hover:bg-sky-500 transition ease-in'>
                                    <span>New Journal</span>
                                </div>
                                <div onClick={props.toggleMode} className='mt-4 rounded-lg px-2 py-2 w-fit cursor-pointer transition ease-in dark:bg-[#f4f4f4] bg-[#212121] hover:text-sky-400 dark:hover:text-sky-600 dark:text-black text-white'>
                                    <span>{props.mode ? light : dark}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='flex justify-center mt-5 px-10'>
                    <div className='max-w-7xl w-full md:px-10 flex flex-col md:flex-row flex-wrap gap-4 dark:text-white'>
                        {props.journals.length !== 0 ? journalElements : <span className='mx-auto mt-5'>Create a new journal entry to get started</span>}
                    </div>
                </div>
            </div>
        </div>
    )
}
